
/**
 * 트윗 유형
 */
export type DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType = typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType[keyof typeof DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DiscoveryGetTrends200PageAllOfThreeContentItemContentTweetsItemBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
